/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { LayoutBasedGridDefinition } from '@gh/core-ui-grid';

@Injectable()
export class MasterZonesGridDefinition extends LayoutBasedGridDefinition {
  options = {
    getRowId: (params) => String(params.data.id),
    rowClassRules: {
      'deleted-class': ({ data }: { data: { active?: boolean } }) => data.active !== true,
    },
  };
}
